import { c as _c } from "react/compiler-runtime";
import { ExternalLinkItem, NavigationItem } from "@shared/types";
import Link from "next/link";
export function FooterNav(t0) {
  const $ = _c(3);
  const {
    navs
  } = t0;
  if (navs && navs.length > 0) {
    let t1;
    if ($[0] !== navs) {
      t1 = navs.map(_temp2);
      $[0] = navs;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <></>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp2(nav) {
  return <div key={nav.id}>{nav.list && nav.list.length > 0 ? <><div className="text-lg md:text-xl font-semibold text-primary-700 mb-3 md:mb-4">{nav.text}</div><ul className="text-base md:text-lg font-medium space-y-2">{nav.list.map(_temp)}</ul></> : <Link href={nav.to || nav.href} target={nav.target || "_self"} className="text-base sm:text-lg font-medium hover:text-primary-600 mb-4">{nav.text}</Link>}</div>;
}
function _temp(listLink) {
  return <li key={listLink.id}><Link href={listLink.href || "/"} target={listLink.target || "_self"} className="text-base sm:text-lg font-medium hover:text-primary-600">{listLink.text}</Link></li>;
}